import React, {Component, Fragment} from 'react';
import { withCookies, Cookies } from 'react-cookie';
import {Helmet} from "react-helmet";
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import BivariateMapComponent from '../MapComponent/BivariateMap';
import MapComponent from '../MapComponent/Map';
import {MenuContainer, SelectAreaPopup} from 'common-components';
import * as mapFunctions from '../../modules/mapboxgl/mapFunctions.js';
import {commitMutation, QueryRenderer, graphql} from 'react-relay';
import environment from '../../RelayEnvironment';
import {longTimeoutEnvironment} from '../../RelayEnvironment';
import {fetchApi} from '../../fetchApi';
import '../../css/bootstrap.min.css';
import '../../css/components/Root/MapRoomCovidRoot.css';
import stopIconImg from '../../images/stopIcon.svg';
import playIconImg from '../../images/playIcon.svg';
import MiniChartsByStateAndCounty from '../CovidDashboard/MiniChartsByStateAndCounty.js';

class MapRoomCovidRoot extends Component {
    constructor(props) {
        super(props);
        const savedAreaIdSelected = null;
        this.state = {
            isLeftMenuOpen: false,
            refreshLayout: false,
            selectedBoardId: null,
            globallyVisible: true,
            mapInitialized: false,
            mapLayers: [this.testIndicator, null, null, null, null, null, null, null, null, null],
            northwest: [0, 0],
            southeast: [0, 0],
            savedAreaIdSelected: savedAreaIdSelected, //'U2F2ZWRBcmVhTm9kZTo0NDU='
            isSelectAreaPopUpVisible: false,
            xOriginTagCrossPopUp: 345,
            yOriginTagCrossPopUp: 150,
            selectedCardForMutation: null,
            isMorePopUpVisible: false,
            xOriginForMorePopUp: 415,
            yOriginForMorePopUp: 150,
            filterByArea: savedAreaIdSelected != null || props.location.search != "",
            oneTimeMapZoomToArea: savedAreaIdSelected != null,
            isSaveMapPopUpVisible: false,
            isShareMapPopUpVisible: false,
            savingAreaInProgress: false,
        }
        this.map = null;
        this.mapSavedAreaId = savedAreaIdSelected;
        this.mapSelectedGeographicEntity = null;
        this.notifiedDriftBot = false;
        this.indicatorData = {};
        this.indicatorLabels = {};
        this.indicatorDataForArea = {};
        this.shapeStyles = null;
        this.findLayerByIndicatorId = mapFunctions.findLayerByIndicatorId.bind(this);
        this.findLayerConfigByIndicatorId = mapFunctions.findLayerConfigByIndicatorId.bind(this);
        this.fitMapToExtent = mapFunctions.fitMapToExtent.bind(this);
        this.flyMapToExtent = mapFunctions.flyMapToExtent.bind(this);
        this.moveAndZoomMap = mapFunctions.moveAndZoomMap.bind(this);
        this.handleMapMoved = mapFunctions.handleMapMoved.bind(this);
        this.handleMapLayerGeographyChanged = mapFunctions.handleMapLayerGeographyChanged.bind(this);
        this.handleMapLayerOpacityChanged = mapFunctions.handleMapLayerOpacityChanged.bind(this);
        this.handleMapLayerPaletteChanged = mapFunctions.handleMapLayerPaletteChanged.bind(this);
        this.handleMapLayerPositionChanged = mapFunctions.handleMapLayerPositionChanged.bind(this);
        this.handleMapLayerRemoved = mapFunctions.handleMapLayerRemoved.bind(this);
        this.handleMapLayerVisibilityChanged = mapFunctions.handleMapLayerVisibilityChanged.bind(this);
        this.handleMapRenderComplete = mapFunctions.handleMapRenderComplete.bind(this);
        this.loadIndicatorData = mapFunctions.loadIndicatorData.bind(this);
        this.loadIndicatorDataForArea = mapFunctions.loadIndicatorDataForArea.bind(this);
        this.loadPreloadedIndicatorLayers = mapFunctions.loadPreloadedIndicatorLayers.bind(this);
        this.refreshMapLayerSource = mapFunctions.refreshMapLayerSource.bind(this);
        this.renderMap = mapFunctions.renderMap.bind(this);
        this.removeMap = mapFunctions.removeMap.bind(this);
        this.setupBaseMapLayers = mapFunctions.setupBaseMapLayers.bind(this);
        this.setPreloadedIndicatorLayers = mapFunctions.setPreloadedIndicatorLayers.bind(this);
        this.updateMapLayer = mapFunctions.updateMapLayer.bind(this);
        this.getMapCenterAndZoom = mapFunctions.getMapCenterAndZoom.bind(this);
        this.getMapPng = mapFunctions.getMapPng.bind(this);
        this.getMapPngUrl = mapFunctions.getMapPngUrl.bind(this);
        this.getMapPdf = mapFunctions.getMapPdf.bind(this);
        this.getMapCenterAndZoom = mapFunctions.getMapCenterAndZoom.bind(this);
        this.setFilterByArea = mapFunctions.setFilterByArea.bind(this);
        this.updateSavedArea = mapFunctions.updateSavedArea.bind(this);
        this.highlightSavedArea = mapFunctions.highlightSavedArea.bind(this);
        this.updateAreaHighlightVisibility = mapFunctions.updateAreaHighlightVisibility.bind(this);
        this.resizeMap = mapFunctions.resizeMap.bind(this);
        this.addHoverPopupToMapLayer = mapFunctions.addHoverPopupToMapLayer.bind(this);
    }

    componentDidMount() {
        /* link OpenLayers map to component after first render to the DOM */
        //this.renderMap();
        if (this.props.match.params.areaid === "signup") {
            this.openSignUpPopUp();
        } else if (this.props.match.params.areaid === "signin") {
            this.openLoginPopUp();
        }
        this.initDashboard4();
        this.initDashboard3();
        this.initDashboard2();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        /*
        if (nextProps.match.params.areaid !== this.props.match.params.areaid) {
            if (nextProps.match.params.areaid === "signup") {
                this.openSignUpPopUp();
            } else if (nextProps.match.params.areaid === "signin") {
                this.openLoginPopUp();
            }
        }
        */
    }

    render() {
        const query = new URLSearchParams(this.props.location.search);
        const mapCardIdToLoad = query.get('id');
        const mapBaseStyleToLoad = query.get('style');
        return (
            <QueryRenderer
                environment={environment}
                query={graphql`
              query MapRoomCovidRootUserQuery
              {
                currentUser
                {
                  edges
                  {
                    node
                    {
                      jsonid
                      username
                      userFirstName
                      userReportName
                      userImage
                      {
                          url
                      }
                    }
                  }
                }
              }
          `}
            variables={{isUpdateTopAndLeftMenu: this.state.isUpdateTopAndLeftMenu, userId: this.state.userId}}
            render={({error, props}) => {
                //console.log(this.props.match);
                if (error) {
                    console.error(error);
                    return <div>Error!</div>;
                }
                if (props) {
                    var userDataProps = props;

                    if (window.drift && this.notifiedDriftBot === false && userDataProps.currentUser != null && userDataProps.currentUser.edges[0] != null) {
                        window.drift.on('ready', function () {
                            window.drift.api.setUserAttributes({
                                email: userDataProps.currentUser.edges[0].node.username,
                                nickname: userDataProps.currentUser.edges[0].node.userFirstName
                            });
                        });
                        this.notifiedDriftBot = true;
                    }
                }
                //userDataProps.currentUser.edges.length
                return (
                    <div className="map-room-covid-root">
                    This is a test.  COVID-19 Dashboard goes here.
                        <div className="container">
                            <MiniChartsByStateAndCounty />
                            <hr />
                            <div id="chart-controls" className="p-2">
                                <form>
                                    <div className="form-row">
                                        <div className="form-group col-sm-12">
                                            <div className="input-title">Change to this layout:</div>
                                            <div className="radio">
                                                <input id="radio-1" name="showRadio" type="radio" defaultChecked={true} value="confirmed" />
                                                <label htmlFor="radio-1" className="radio-label mb-0 input-sub-title">Confirmed cases</label>
                                                <input id="radio-2" name="showRadio" type="radio" value="deaths" />
                                                <label htmlFor="radio-2" className="radio-label ml-3  mb-0 input-sub-title">Deaths</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-sm-6 col-6">
                                            <label className="input-title">State</label>
                                            <select className="form-control" id="stateList"></select>
                                        </div>
                                        <div className="form-group col-sm-6 col-6">
                                            <label className="input-title">County</label>
                                            <select className="form-control" id="countyList"></select>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div>
                                            <img id="stopBtn" src={stopIconImg} className="" alt="stop" height="25" width="30" style={{"cursor": "pointer", "marginRight": "0.4em"}} />
                                            <img id="playBtn" src={playIconImg} className="d-none" alt="play" height="25" width="30" style={{"cursor": "pointer", "marginRight": "0.4em"}} />
                                        </div>
                                            <label style={{"display": "flex", "alignItems": "center"}}>
                                            <input id="rangeInput" name="i" className="slider" type="range" min={0} max={70} defaultValue="0" step={1} style={{"width": "150px"}} />
                                            <output id="rangeOutput" className="input-sub-title" name="o" style={{"marginLeft": "0.4em"}}></output>
                                        </label>
                                    </div>
                                </form>
                            </div>
                            <div id="chart2"></div>
                            <hr />
                            <div id="line-chart-controls" className="p-2">
                                <form id="line-chart-form">
                                    <div className="form-row">
                                        <div className="form-group col-sm-12">
                                            <div className="radio">
                                                <input id="radio-1b" name="showRadio2" type="radio" defaultChecked={true} value="confirmed" />
                                                <label htmlFor="radio-1b" className="radio-label mb-0 input-sub-title">Confirmed cases</label>
                                                <input id="radio-2b" name="showRadio2" type="radio" value="deaths" />
                                                <label htmlFor="radio-2b" className="radio-label ml-3 mb-0 input-sub-title">Deaths</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-sm-12">
                                            <div className="input-title">Doubling periods guidelines</div>
                                            <label style={{"display": "inline-block", "margin": "5px 10px 3px 0"}}
                                                   className="check-container input-sub-title">
                                                Every day
                                                <input type="checkbox" name="daysInput" defaultChecked={true} style={{"verticalAlign": "baseline"}}
                                                       value="1" /> <span className="checkmark"></span>
                                            </label>
                                            <label style={{"display": "inline-block", "margin": "5px 10px 3px 0"}}
                                                   className="check-container input-sub-title">
                                                Every 3 days
                                                <input type="checkbox" name="daysInput" defaultChecked={true} style={{"verticalAlign": "baseline"}}
                                                       value="3" /> <span className="checkmark"></span>
                                            </label>
                                            <label style={{"display": "inline-block", "margin": "5px 10px 3px 0"}}
                                                   className="check-container input-sub-title">
                                                Every week
                                                <input type="checkbox" name="daysInput" defaultChecked={true} style={{"verticalAlign": "baseline"}}
                                                       value="7" /> <span className="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-6">
                                            <label className="input-title">State</label>
                                            <select className="form-control" id="stateList2"></select>
                                        </div>
                                        <div className="form-group col-6">
                                            <label className="input-title">County</label>
                                            <select className="form-control" id="countyList2"></select>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-6">
                                            <div className="input-title">Set origin</div>
                                            <input id="setOrigin" className="slider" type="range" min="0" max="15" step="1" defaultValue="4" />
                                            <output id="setOriginOutput" style={{"fontSize": "14px"}}>Days since 100
                                                confirmed
                                            </output>
                                        </div>
                                        <div className="form-group col-6">
                                            <div className="input-title">Set timespan</div>
                                            <input id="setTimespan" className="slider" type="range" min="10" max="100" step="1" defaultValue="40" />
                                            <output id="setTimespanOutput" style={{"fontSize": "14px"}}>Show 40 days
                                                confirmed
                                            </output>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div id="line-chart"></div>
                            <hr />

                            <div className="mt-3">
                                <form id="line-chart-form2">
                                    <div className="form-row">
                                        <div className="form-group col-sm-12 d-flex">
                                            <div className="input-title mr-3">Show By</div>
                                            <div className="radio">
                                                <input id="radio-2c" name="showRadio3" type="radio" defaultChecked={true} value="Count" />
                                                <label htmlFor="radio-2c" className="radio-label input-sub-title mb-0">Count</label>
                                                <input id="radio-1c" name="showRadio3" type="radio" value="Percentage" />
                                                <label htmlFor="radio-1c" className="radio-label ml-3 mb-0 input-sub-title">Percentage</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-sm-6 col-6">
                                            <label className="input-title">State</label>
                                            <select className="form-control" id="stateList3"></select>
                                        </div>
                                        <div className="form-group col-sm-6 col-6">
                                            <label className="input-title">County</label>
                                            <select className="form-control" id="countyList3"></select>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-sm-12"   >
                                            <div className="input-title" id="setCurrentOutput">Current date: </div>
                                            <input id="setCurrent" className="slider" type="range" min="0" max="15" step="1" defaultValue="4" />
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div>
                                <table className="table table-bordered">
                                    <thead><tr id="tableHeader"></tr></thead>
                                    <tbody id="tableBody"></tbody>
                                </table>
                                <div className="form-row">
                                    <div className="form-group col-sm-12">
                                        <div className="input-title">Show</div>
                                        <div className="radio">
                                            <input id="radio-3" name="tableRadio" type="radio" defaultChecked={true} value="10" />
                                            <label htmlFor="radio-3" className="radio-label mb-0 input-sub-title">10</label>
                                            <input id="radio-4" name="tableRadio" type="radio" value="20" />
                                            <label htmlFor="radio-4" className="radio-label ml-3  mb-0 input-sub-title">20</label>
                                            <input id="radio-5" name="tableRadio" type="radio" value="30" />
                                            <label htmlFor="radio-5" className="radio-label ml-3  mb-0 input-sub-title">30</label>
                                            <input id="radio-6" name="tableRadio" type="radio" value="All" />
                                            <label htmlFor="radio-6" className="radio-label ml-3  mb-0 input-sub-title">All</label>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            
                            <iframe zoom="10%" src="https://www.broadstreet.io/map/embed/?id=Qm9hcmRDYXJkVXNlTm9kZTo1NzMxNjU=" allowFullScreen="" width="100%" height="500px" frameBorder="0"></iframe>
                        </div>
                    </div>);
        }}/>)
    }
    
    initDashboard2 = () => {
        let d3 = window.d3;
        let new_data = window.new_data;
        var data;
        var raw_colors = function getColor() {
            const arr = [];
            for (var i = 0; i< 50; i++) {
                arr.push(getRandomColor())
            }
            function getRandomColor() {
                var letters = '23456789AB';
                var color = '#';
                for (var i = 0; i < 6; i++) {
                    color += letters[Math.floor(Math.random() * 10)];
                }
                return color;
            }
            return arr
        }();
        var y_type = 'confirmed';
        var selected_regions = [];
        var svg = d3.select('svg#chart2');
        var params = {
            width: 800,
            height: 500,
            opac_weak: 0.4,
            margin: ({top: 30, right: 10, bottom: 35, left: 50}),
            xmin: 1,
            xmax: 1e6,
            ymin: 1,
            ymax: 1e6,
        }
        var x, y;
        var viz_data, color;
        var curr_date;
        var statData = {};
        var selectionKey = 'state';
        var autoPlay = true;
        var timer = null;
        var delay = 300;
        var direction = 1;
        var loop = true;
        var alternate = false;
        var dateOffset = (24 * 60 * 60 * 1000) * 70; //70 days
        var todayDate = new Date();
        var dateValues = d3.timeDays(todayDate.getTime() - dateOffset, todayDate);
        var values = Array.from(dateValues);
        var rangInput = document.getElementById('rangeInput');
        var code = 'fips';
        var nameKey = 'county';

        document.getElementById('radio-1').addEventListener('change', () => {
            initDashboard2();
        });
        document.getElementById('radio-2').addEventListener('change', () => {
            initDashboard2();
        });

        const firstDate = new_data.length && new_data[0].day && new_data[0].day[0];
        // const firstDate = "20" + date[4] + date[5] + '-' + date[0] + date[1] + '-' + date[2] + date[3];

        const date = new Date(d3.timeParse("%Y-%m-%d")("20" + firstDate[4] + firstDate[5] + '-' + firstDate[0] + firstDate[1] + '-' + (firstDate[2] + firstDate[3])));
        // date.setDate(date.getDate() - 1);

        const diffTime = Math.abs(todayDate - date);
        dateOffset = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        rangInput.setAttribute("max", parseInt(dateOffset) - 1)
        dateValues = d3.timeDays(date, todayDate);
        values = Array.from(dateValues);

        new_data.forEach((d, i) => {
            var stateDataAdded = false;
            if (d.state !== '') {
                if (!statData[d.state]) {
                    statData[d.state] = {county: {}}
                }
                if ((d.county.includes('state') || !d.county.includes(',') || d.county.split(',')[0].trim().toUpperCase() === d.county.split(',')[1].trim().toUpperCase()) && !statData[d.state].data) {
                    statData[d.state].data = d;
                    statData[d.state].data.confirmed = [];
                    statData[d.state].data.deaths = [];
                    stateDataAdded = true
                }
                d.day.filter(function (item, pos) {
                    return d.day.indexOf(item) === pos;
                }).forEach((date, i) => {
                    const newDate = "20" + date[4] + date[5] + '-' + date[0] + date[1] + '-' + date[2] + date[3];
                    const county = d.county.split(',')[0].replace('County', '');
                    if (stateDataAdded) {
                        statData[d.state].data.confirmed.push([newDate, d.tstpos[i] ? d.tstpos[i] : 0]);
                        statData[d.state].data.deaths.push([newDate, d.mort[i] ? d.mort[i] : 0]);
                    } else {
                        if (!statData[d.state].county[county]) {
                            statData[d.state].county[county] = {
                                confirmed: [],
                                deaths: [],
                                fips: d.fips,
                                state: d.state,
                                county: county
                            }
                        }
                        statData[d.state].county[county].confirmed.push([newDate, d.tstpos[i] ? d.tstpos[i] : 0]);
                        statData[d.state].county[county].deaths.push([newDate, d.mort[i] ? d.mort[i] : 0]);
                    }
                })
            }
        });

        Object.keys(statData).forEach((d) => {
            Object.keys(statData[d].county).forEach((c) => {
                statData[d].county[c].confirmed = add_past_week_number(statData[d].county[c].confirmed);
                statData[d].county[c].deaths = add_past_week_number(statData[d].county[c].deaths);
            });
            statData[d].data.confirmed = add_past_week_number(statData[d].data.confirmed);
            statData[d].data.deaths = add_past_week_number(statData[d].data.deaths);
        });

        function createXAxis(g) {
            g.attr("transform", `translate(0,${params.height - params.margin.bottom})`)
                .call(d3.axisBottom(x).ticks(params.width / 80, ".0s"))
                .call(g => g.append("text")
                    .attr('class', 'text-gray-dark')
                    .attr("x", params.width + params.margin.left)
                    .attr("y", params.margin.bottom + 10)
                    .attr("fill", "currentColor")
                    .attr("text-anchor", "end")
                    .attr("font-family", "ProximaNova-Regular")
                    .text(`Total ${y_type} →`))
            g.selectAll('line').remove();
            g.select('path.domain').attr('stroke', '#424B54')
            g.selectAll('.tick').selectAll('text').attr('class', 'text-gray').attr("font-family", "ProximaNova-Regular")
        }

        function createYAxis(g) {
            g.attr("transform", `translate(${params.margin.left},0)`)
                .call(d3.axisLeft(y).ticks(params.height / 80, ".0s"))
                .call(g => g.append("text")
                    .attr('class', 'text-gray-dark')
                    .attr("x", -params.margin.left)
                    .attr("y", params.margin.top - 15)
                    .attr("fill", "currentColor")
                    .attr("text-anchor", "start")
                    .attr("font-family", "ProximaNova-Regular")
                    .text(`↑ New ${y_type} (past week)`))
            g.selectAll('line').remove();
            g.select('path.domain').attr('stroke', '#424B54')
            g.selectAll('.tick').selectAll('text').attr('class', 'text-gray').attr("font-family", "ProximaNova-Regular")
        }

        function setSelectStateDropdown() {
            document.getElementById('stateList').innerText = '';
            Object.keys(statData).forEach((key, i) => {
                var option = document.createElement('option');
                if (i === 0) {
                    option.innerText = 'All States';
                    option.value = 'All';
                    option.selected = true;
                    document.getElementById('stateList').appendChild(option);
                    option = document.createElement('option');
                }
                let stateText = statData[key].data.county.includes('state') ? statData[key].data.county.replace('(state)', '') : statData[key].data.county.split(',')[0]
                option.innerText = stateText;
                option.value = key;
                document.getElementById('stateList').appendChild(option)
            });
            params.width = document.getElementById("chart2").clientWidth - params.margin.left - params.margin.right;
            document.getElementById('stateList').addEventListener('change', (selected) => {
                setCountyDropdown();
                initDashboard2();
            })
        }

        function setCountyDropdown() {
            document.getElementById('countyList').innerText = '';
            if (statData[document.getElementById('stateList').value]) {
                var county = statData[document.getElementById('stateList').value].county;
                Object.keys(county).forEach((key, i) => {
                    var option = document.createElement('option');
                    if (i === 0) {
                        option.innerText = 'Select County';
                        option.value = 'temp';
                        option.selected = true;
                        document.getElementById('countyList').appendChild(option);
                        option = document.createElement('option');
                        option.innerText = 'All Counties';
                        option.value = 'All';
                        // option.selected = true;
                        document.getElementById('countyList').appendChild(option);
                        option = document.createElement('option');
                    }
                    option.innerText = key;
                    option.value = key;
                    document.getElementById('countyList').appendChild(option)
                });
                document.getElementById('countyList').addEventListener('change', (selected) => {
                    initDashboard2();
                })
            }
        }

        function start() {
            document.getElementById('playBtn').className = "d-none";
            document.getElementById('stopBtn').className = "d-block";
            timer = delay === null
                ? requestAnimationFrame(tick)
                : setInterval(tick, delay);
        }

        function stop() {
            document.getElementById('playBtn').className = "d-block";
            document.getElementById('stopBtn').className = "d-none";
            if (delay === null) cancelAnimationFrame(timer);
            else clearInterval(timer);
            timer = null;
        }

        function tick() {
            if (delay === null) timer = requestAnimationFrame(tick);
            if (rangInput.valueAsNumber === (direction > 0 ? values.length - 1 : direction < 0 ? 0 : NaN)) {
                if (!loop) return stop();
                if (alternate) direction = -direction;
            }
            rangInput.valueAsNumber = ((rangInput.valueAsNumber + direction + values.length) % values.length);
            rangInput.dispatchEvent(new CustomEvent("input", {bubbles: true}));
        }

        document.getElementById('stopBtn').addEventListener('click', onClickStopButton);
        document.getElementById('playBtn').addEventListener('click', onClickPlayBtn);

        function onClickStopButton() {
            stop();
        }

        function onClickPlayBtn() {
            if (timer) {
                return stop();
            }
            direction = alternate && rangInput.valueAsNumber === values.length - 1 ? -1 : 1;
            rangInput.valueAsNumber = (rangInput.valueAsNumber + direction) % values.length - 1;
            rangInput.dispatchEvent(new CustomEvent("input", {bubbles: true}));
            start();
        }

        rangInput.addEventListener('input', (e) => {
            if (e && e.isTrusted && timer) {
                onClickPlayBtn();
            }
            if (rangInput.valueAsNumber === values.length - 1) {
                stop();
            }
            curr_date = values[rangInput.valueAsNumber];
            document.getElementById('rangeOutput').value = values[rangInput.valueAsNumber] ? values[rangInput.valueAsNumber]
                    .toLocaleString("ko-KR", {year: "numeric", month: "numeric", day: "numeric"}) :
                values[values.length - 1].toLocaleString("ko-KR", {year: "numeric", month: "numeric", day: "numeric"});
            initDashboard2();
        })

        function isSingleStateSelected() {
            return document.getElementById('stateList').value !== 'All' && document.getElementById('countyList').value === 'temp' ? document.getElementById('stateList').value : null
        }

        function initDashboard2() {
            d3.select('#chart2').select('svg').remove();
            y_type = document.querySelector('input[name="showRadio"]:checked').value;
            if (document.getElementById('stateList').value === 'All' || isSingleStateSelected()) {
                selected_regions = Object.keys(statData);
                if (!isSingleStateSelected()) {
                    document.getElementById('countyList').disabled = true;
                    document.getElementById('countyList').readOnly = true;
                    document.getElementById('countyList').value = null;
                    document.getElementById('countyList').innerText = '';
                } else {
                    document.getElementById('countyList').disabled = false;
                    document.getElementById('countyList').readOnly = false;
                }
                selectionKey = 'state';
                data = Object.keys(statData).map((d) => {
                    return statData[d].data;
                });
                color = d3.scaleOrdinal(data.map(d => d[selectionKey]), raw_colors).unknown("black");
            } else {
                document.getElementById('countyList').disabled = false;
                document.getElementById('countyList').readOnly = false;
                selectionKey = 'county';
                data = Object.keys(statData[document.getElementById('stateList').value].county).map((obj) => {
                    return statData[document.getElementById('stateList').value].county[obj]
                });
                selected_regions = data.map(d => d[selectionKey]);
                color = d3.scaleOrdinal(data.map(d => d[selectionKey]), raw_colors).unknown("black");
            }

            viz_data = data
                .filter(d => selected_regions.includes(d[selectionKey])).map(function (d) {
                    return {
                        'state': d.state,
                        'country_name': d.state,
                        'county': d.county,
                        'confirmed': d.confirmed.filter(a => new Date(a[0]) < curr_date),
                        'deaths': d.deaths.filter(a => new Date(a[0]) < curr_date),
                        'fips': d.fips,
                    }
                });
            createYScale();
            createXScale();
            createSVG();
        }

        function add_past_week_number(a) {
            var new_array = [[a[0][0], a[0][1], a[0][1]]];
            var curr_sum = 0;
            var min_idx = 0;
            for (var i = 1; i < a.length; i++) {
                min_idx = d3.max([0, i - 7]);
                if (min_idx != 0) {
                    curr_sum = a[i][1] - a[min_idx][1];
                } else {
                    curr_sum = a[i][1];
                }
                new_array.push([a[i][0], a[i][1], curr_sum])
            }
            return new_array;
        }

        function createXScale() {
            x = d3.scaleLog([params.xmin, params.xmax], [params.margin.left, params.width + params.margin.left - params.margin.right]).clamp(true);
        }

        function createYScale() {
            y = d3.scaleLog([params.ymin, params.ymax], [params.height - params.margin.bottom, params.margin.top]).clamp(true);
        }

        function createSVG() {
            svg = d3.select('#chart2').append("svg");
            // svg.attr("viewBox", [0, 0, params.width, params.height]);
            svg.attr('width', params.width + params.margin.left + params.margin.right)
                .attr('height', params.height + params.margin.top + params.margin.bottom);
            // guides = svg.append("g").attr("id", "guides");
            // guides.attr('transform', 'translate(' + 0 + ',' + 0 + ')');
            // guidesText = svg.append("g");
            draw_axes(svg);
            draw_trajectories(svg);
            draw_date(svg);

            svg.append("text").attr("id", "fullname");
        }

        function draw_axes(svg) {
            svg.append("g").call(createXAxis);
            svg.append("g").call(createYAxis);
        }


        function get_path(d) {
            const l = d3.line();
            const path = l(d.filter(d => (d[1] > 10 && d[2] > 10)).map(d => [x(d[1]), y(d[2])]))
            return path;
        }

        function draw_trajectories(svg) {
            svg.append("g").selectAll("path").data(viz_data).join("path")
                .attr("class", d => `cls-${d[code]}`)
                .attr("stroke", d => color(d[selectionKey])).attr("fill", "none")
                .call(setFilOpc)
                .attr("d", d => get_path(d[y_type]))
                .on("mouseover", onMouseOver).on("mouseout", onMouseOut);

            svg.append("g").selectAll("circle").data(viz_data).join("circle")
                .attr("class", d => `cls-${d[code]}`)
                .attr("fill", d => {
                    return color(d[selectionKey])
                })
                .call(setFilOpc)
                .attr("cx", d => {
                    if (d[y_type].length === 0 || !d[y_type][d[y_type].length - 1][1]) {
                        return -200
                    }
                    return x(d[y_type][d[y_type].length - 1][1])
                })
                .attr("cy", d => {
                    if (d[y_type].length === 0 || !d[y_type][d[y_type].length - 1][2]) {
                        return params.height * 2
                    }
                    return y(d[y_type][d[y_type].length - 1][2])
                })
                .attr("r", 3)
                .on("mouseover", onMouseOver).on("mouseout", onMouseOut);

            svg.append("g").selectAll("text").data(viz_data).join("text").text(d => {
                return (d[nameKey].includes('state') ? d[nameKey].replace('(state)', '') : d[nameKey].split(',')[0]).replace('County', '');
            })
                .attr("class", d => `cls-${d[code]} node-title`)
                .attr("font-size", '1.2em')
                .attr("dominant-baseline", 'middle')
                .attr("pointer-events", 'none')
                .attr("fill", d => color(d[selectionKey]))
                .call(setFilOpc)
                .attr("x", d => {
                    if (d[y_type].length === 0 || !d[y_type][d[y_type].length - 1][1]) {
                        return -200
                    }
                    return x(d[y_type][d[y_type].length - 1][1]) + 10
                })
                .attr("y", d => {
                    if (d[y_type].length === 0 || !d[y_type][d[y_type].length - 1][2]) {
                        return -200
                    }
                    return y(d[y_type][d[y_type].length - 1][2])
                })
        }

        function isCountySelected() {
            return document.getElementById('stateList').value !== 'All' && document.getElementById('countyList').value !== 'All' && document.getElementById('countyList').value !== 'temp' ? document.getElementById('countyList').value : null
        }

        function setFilOpc(selection) {
            if (isCountySelected()) {
                return selection.attr("fill-opacity", function (d) {
                    if (d[selectionKey] === isCountySelected()) {
                        this.parentNode.appendChild(this);
                    } else if (d3.select(this).attr('class').includes('node-title')) {
                        return 0;
                    }
                    return d[selectionKey] === isCountySelected() ? 1 : 0.2
                }).attr("stroke-opacity", (d) => {
                    return d[selectionKey] === isCountySelected() ? 1 : 0.2
                }).attr("stroke-width", (d) => {
                    return d[selectionKey] === isCountySelected() ? 4 : 2
                }).attr("r", (d) => {
                    return d[selectionKey] === isCountySelected() ? 5 : 3
                })
            }
            if (isSingleStateSelected()) {
                return selection.attr("fill-opacity", function (d) {
                    if (d[selectionKey] === isSingleStateSelected()) {
                        this.parentNode.appendChild(this);
                    } else if (d3.select(this).attr('class').includes('node-title')) {
                        return 0;
                    }
                    return d[selectionKey] === isSingleStateSelected() ? 1 : 0.2
                }).attr("stroke-opacity", (d) => {
                    return d[selectionKey] === isSingleStateSelected() ? 1 : 0.2
                }).attr("stroke-width", (d) => {
                    return d[selectionKey] === isSingleStateSelected() ? 4 : 2
                }).attr("r", (d) => {
                    return d[selectionKey] === isSingleStateSelected() ? 5 : 3
                })
            } else {
                return selection.attr("fill-opacity", function () {
                    if (d3.select(this).attr('class').includes('node-title')) {
                        return 0;
                    }
                    return params.opac_weak
                })
                    .attr("stroke-opacity", params.opac_weak)
                    .attr("stroke-width", 2)
                    .attr("r", 3)
            }
        }

        function draw_date(svg) {
            svg.append("g")  // Date
                .append("text").text(d3.timeFormat("%b %d")(curr_date))
                .style("text-anchor", "end")
                .attr("font-size", 50).attr("fill-opacity", 0.1)
                .attr("dominant-baseline", "ideographic")
                .attr("font-style", "bold")
                .attr("font-family", "ProximaNova-Regular")
                .attr("x", x(params.xmax)).attr("y", y(params.ymin));
        }

        function code_to_name(selectedCode) {
            return data.find(d => d[code] === selectedCode.split('cls-')[1].replace(' node-title', ''))[nameKey];
        }

        function onMouseOver(selected) {
            const country_code = d3.select(this).attr("class");
            d3.selectAll(`.${country_code}`).attr("fill-opacity", 1).attr("stroke-opacity", 1).attr("stroke-width", 3)
                .attr("r", 5);

            d3.select("#fullname").text(code_to_name(country_code).replace('(state)', '').split(',')[0])
                .style("text-anchor", "end")
                .attr("font-size", params.width < 500 ? '1.4em' : '2.6em')
                .attr("fill-opacity", 0.5)
                .attr("fill", "black")
                .attr("pointer-event", "none")
                .attr("font-style", "bold")
                .attr("font-family", "ProximaNova-Regular, sans-serif")
                .attr("x", x(params.xmax)).attr("y", y(params.ymax) + 20);
        }

        function onMouseOut() {
            const country_code = d3.select(this).attr("class");
            d3.selectAll(`.${country_code}`)
                .call(setFilOpc);
            d3.select("#fullname").attr("fill-opacity", 0);
        }

        setSelectStateDropdown();
        initDashboard2();
        if (autoPlay) {
            start()
        } else {
            stop();
        }
    }
    
    initDashboard3 = () => {
        var stateText;
        let d3 = window.d3;
        let new_data = window.new_data;
        var min_y_values;
        var raw_colors = function getColor() {
            const arr = [];
            for (var i = 0; i< 50; i++) {
                arr.push(getRandomColor())
            }
            function getRandomColor() {
                var letters = '23456789AB';
                var color = '#';
                for (var i = 0; i < 6; i++) {
                    color += letters[Math.floor(Math.random() * 10)];
                }
                return color;
            }
            return arr
        }();
        var svg;
        var y_type = 'confirmed';
        var y, x;
        var pivot_n = 1;
        var num_days = 45;
        var doubling_periods = [1, 3, 7];
        var doubling_period_labels;
        var selected_regions = [];
    // var selected_regions = ["Europe & Central Asia", "East Asia & Pacific", "North America"];

        var color;
        var pivot_bisector = d3.bisector(d => d[1]);
        var pivot_values = [1, 5, 10, 50, 100, 200, 500, 1000, 2000, 5000, 10000, 13000, 15000, 20000, 50000, 100000];
        var pivot = pivot_values[pivot_n];
        var params = {
            width: 600,
            height: 400,
            margin: ({top: 30, right: 10, bottom: 35, left: 50}),
            ymin: 1,
            ymax: 2e6,
            xmin: 0,
            xmax: num_days,
            opac_weak: 0.4
        };
        var data;
        var viz_data;
        var guides, guidesText, last_index;
        var selectionKey = 'state';
        var code = 'fips';
        var nameKey = 'county';
        var statData = {};
        document.getElementsByName('daysInput').forEach((ele) => {
            ele.addEventListener('change', (element) => {
                if (element.target.checked) {
                    doubling_periods.push(parseInt(element.target.value))
                } else {
                    doubling_periods.splice(doubling_periods.indexOf(parseInt(element.target.value)), 1);
                }
                init3();
            });
        });
        new_data.forEach((d, i) => {
            var stateDataAdded = false;
            if (d.state !== '') {
                if (!statData[d.state]) {
                    statData[d.state] = {county: {}}
                }
                if ((d.county.includes('state') || !d.county.includes(',') || d.county.split(',')[0].trim().toUpperCase() === d.county.split(',')[1].trim().toUpperCase()) && !statData[d.state].data) {
                    statData[d.state].data = d;
                    statData[d.state].data.confirmed = [];
                    statData[d.state].data.deaths = [];
                    stateDataAdded = true
                }
                d.day.filter(function (item, pos) {
                    return d.day.indexOf(item) === pos;
                }).forEach((date, i) => {
                    const newDate = "20" + date[4] + date[5] + '-' + date[0] + date[1] + '-' + date[2] + date[3];
                    const county = d.county.split(',')[0].replace('County', '');
                    if (stateDataAdded) {
                        statData[d.state].data.confirmed.push([newDate, d.tstpos[i]]);
                        statData[d.state].data.deaths.push([newDate, d.mort[i]]);
                    } else {
                        if (!statData[d.state].county[county]) {
                            statData[d.state].county[county] = {
                                confirmed: [],
                                deaths: [],
                                fips: d.fips,
                                state: d.state,
                                county: county
                            }
                        }
                        statData[d.state].county[county].confirmed.push([newDate, d.tstpos[i]]);
                        statData[d.state].county[county].deaths.push([newDate, d.mort[i]]);
                    }
                })
            }
        });
        document.getElementById('radio-1b').addEventListener('change', () => {
            console.log("radio-1b clicked");
            init3();
            document.getElementById('setTimespanOutput').innerText = `Show ${params.xmax} days ${y_type}`;
            document.getElementById('setOriginOutput').innerText = `Days since ${pivot} ${y_type}`;
        });
        document.getElementById('radio-2b').addEventListener('change', () => {
            console.log("radio-2b clicked");
            init3();
        });
        document.getElementById('setOrigin').value = pivot_n;
        document.getElementById('setOrigin').addEventListener('input', (ele) => {
            pivot_n = ele.target.value;
            pivot = pivot_values[pivot_n];
            //params.ymin = pivot;
            params.ymin = 1;
            init3();
        });
        document.getElementById('setTimespan').value = num_days;
        document.getElementById('setTimespan').addEventListener('input', (ele) => {
            num_days = ele.target.value <= 25 ? 25 : ele.target.value;
            params.xmax = num_days;
            init3();
        });

        function setSelectStateDropdown() {
            document.getElementById('stateList2').innerText = '';
            Object.keys(statData).forEach((key, i) => {
                var option = document.createElement('option');
                if (i === 0) {
                    option.innerText = 'All States';
                    option.value = 'All';
                    option.selected = true;
                    document.getElementById('stateList2').appendChild(option);
                    option = document.createElement('option');
                }
                stateText = statData[key].data.county.includes('state') ? statData[key].data.county.replace('(state)', '') : statData[key].data.county.split(',')[0]
                option.innerText = stateText;
                option.value = key;
                document.getElementById('stateList2').appendChild(option)
            });
            document.getElementById('stateList2').addEventListener('change', (selected) => {
                setCountyDropdown();
                init3();
            });
            params.width = document.getElementById("line-chart").clientWidth - params.margin.left - params.margin.right;
            // params.height = params.height;
        }

        function setCountyDropdown() {
            document.getElementById('countyList2').innerText = '';
            if (statData[document.getElementById('stateList2').value]) {
                var county = statData[document.getElementById('stateList2').value].county;
                Object.keys(county).forEach((key, i) => {
                    var option = document.createElement('option');
                    if (i === 0) {
                        option.innerText = 'Select County';
                        option.value = 'temp';
                        option.selected = true;
                        document.getElementById('countyList2').appendChild(option);
                        option = document.createElement('option');
                        option.innerText = 'All Counties';
                        option.value = 'All';
                        // option.selected = true;
                        document.getElementById('countyList2').appendChild(option);
                        option = document.createElement('option');
                    }
                    option.innerText = key;
                    option.value = key;
                    document.getElementById('countyList2').appendChild(option)
                });
                document.getElementById('countyList2').addEventListener('change', (selected) => {
                    init3();
                })
            }
        }

        function createYAxis(g) {
            g.attr("transform", `translate(${params.margin.left},0)`)
                .call(d3.axisLeft(y).ticks(params.height / 80, ".0s"))
                // .call(d3.axisLeft(y).ticks(params.height / 80, ",").tickFormat(d3.format(".0s")))
                .call(g => g.append("text")
                    .attr('class', 'text-gray-dark')
                    .attr("x", -params.margin.left)
                    .attr("y", params.margin.top - 10)
                    .attr("fill", '#424B54')
                    .attr("font-family", "ProximaNova-Regular")
                    .attr("text-anchor", "start")
                    .text(`↑ Number of ${y_type}`));
            g.selectAll('line').remove();
            g.select('path.domain').attr('stroke', '#424B54');
            g.selectAll('.tick').selectAll('text').attr('class', 'text-gray').attr("font-family", "ProximaNova-Regular")
        }

        function createXAxis(g) {
            g.attr("transform", `translate(0,${params.height - params.margin.bottom})`)
                .call(d3.axisBottom(x).ticks(params.width / 80))
                .call(g => g.append("text")
                    .attr("x", params.width + params.margin.left)
                    .attr("y", params.margin.bottom + 5)
                    .attr('class', 'text-gray-dark')
                    .attr("font-family", "ProximaNova-Regular")
                    .attr("fill", '#424B54')
                    .attr("text-anchor", "end")
                    .text(`Days since ${pivot_values[pivot_n]} ${y_type} →`));
            g.selectAll('line').remove();
            g.select('path.domain').attr('stroke', '#424B54');
            g.selectAll('.tick').selectAll('text').attr('class', 'text-gray').attr("font-family", "ProximaNova-Regular")
        }

        function get_text_rotation_angle(doubling_period) {
            const radians = 0.0174532925;
            return -Math.atan((y(params.ymin) - y(params.ymin * 2)) / (x(doubling_period) - x(0))) / radians;
        }

        function code_to_name(selectedCode) {
            return data.find(d => d[code] === selectedCode.split('cls-')[1].replace(' node-title', ''))[nameKey];
        }


        function createYScale() {
            y = d3.scaleLog([params.ymin, params.ymax], [params.height - params.margin.bottom, params.margin.top])
        }

        function createXScale() {
            x = d3.scaleLinear().domain([params.xmin, params.xmax])
                .range([params.margin.left, params.width + params.margin.left - params.margin.right])
        }

        function isCountySelected() {
            return document.getElementById('stateList2').value !== 'All' && document.getElementById('countyList2').value !== 'All' && document.getElementById('countyList2').value !== 'temp' ? document.getElementById('countyList2').value : null
        }


        function doubling_periodsMapper() {
            doubling_period_labels = doubling_periods.map(function (d, i) {
                d = Number(d);
                const candidate_n = params.xmax / d;
                const candidate_y = Math.pow(2, candidate_n) * params.ymin;
                if (candidate_y < params.ymax) {
                    return {i, 'period': d, 'x': params.xmax, 'y': candidate_y};
                } else {
                    return {i, 'period': d, 'x': Math.log2(params.ymax / params.ymin) * d, 'y': params.ymax};
                }
            })
        }

        function get_path(d) {
            const l = d3.line();
            return l(d.map(function (e, i) {
                try {
                    let parsed_e = parseInt(e);
                    if (parsed_e === 0) {
                        return [x(i), y.range()[0]]
                    }
                    else if(isNaN(parsed_e)) {
                        console.log("invalid y value detected", e);
                        return [x(0), y(0)]
                    } else {
                        //console.log(x(i), y(e));
                        if(y(e) == null) {
                            console.log("Invalid y value detected", e);
                        } else {
                            return [x(i), y(e) != null ? y(e) : y(0)]
                        }
                    }
                } catch(ex) { console.log("caught exception", ex); }finally { }
            }));
        }

        function createSVG() {
            svg = d3.select('#line-chart').append("svg");
            // svg.attr("viewBox", [0, 0, params.width, params.height]);
            svg.attr('width', params.width + params.margin.left + params.margin.right)
                .attr('height', params.height + params.margin.top + params.margin.bottom);
            guides = svg.append("g").attr("id", "guides");
            guides.attr('transform', 'translate(' + 0 + ',' + 0 + ')');
            guidesText = svg.append("g");
            draw_axes(svg);
            draw_doubling_lines(svg);
            draw_trajectories(svg);

            svg.append("text").attr("id", "fullname");
        }

        function setFilOpc(selection) {
            if (isCountySelected()) {
                return selection.attr("fill-opacity", function (d) {
                    if (d[selectionKey] === isCountySelected()) {
                        this.parentNode.appendChild(this);
                    } else if (d3.select(this).attr('class').includes('node-title')) {
                        return 0;
                    }
                    return d[selectionKey] === isCountySelected() ? 1 : 0.2
                }).attr("stroke-opacity", (d) => {
                    return d[selectionKey] === isCountySelected() ? 1 : 0.2
                }).attr("stroke-width", (d) => {
                    return d[selectionKey] === isCountySelected() ? 4 : 2
                }).attr("r", (d) => {
                    return d[selectionKey] === isCountySelected() ? 5 : 3
                })
            }
            if (isSingleStateSelected()) {
                return selection.attr("fill-opacity", function (d) {
                    if (d[selectionKey] === isSingleStateSelected()) {
                        this.parentNode.appendChild(this);
                    } else if (d3.select(this).attr('class').includes('node-title')) {
                        return 0;
                    }
                    return d[selectionKey] === isSingleStateSelected() ? 1 : 0.2
                }).attr("stroke-opacity", (d) => {
                    return d[selectionKey] === isSingleStateSelected() ? 1 : 0.2
                }).attr("stroke-width", (d) => {
                    return d[selectionKey] === isSingleStateSelected() ? 4 : 2
                }).attr("r", (d) => {
                    return d[selectionKey] === isSingleStateSelected() ? 5 : 3
                })
            } else {
                return selection.attr("fill-opacity", function () {
                    if (d3.select(this).attr('class').includes('node-title')) {
                        return 0;
                    }
                    return params.opac_weak
                })
                    .attr("stroke-opacity", params.opac_weak)
                    .attr("stroke-width", 2)
                    .attr("r", 3)
            }
        }

        function draw_trajectories(svg) {
            svg.append("g").selectAll("path").data(viz_data).join("path")
                .attr("class", d => `cls-${d[code]}`)
                .attr("stroke", d => color(d[selectionKey]))
                .attr("fill", "none")
                .call(setFilOpc)
                .attr("d", d => get_path(d.shifted))
                .on("mouseover", onMouseOver)
                .on("mouseout", onMouseOut);

            svg.append("g").selectAll("circle").data(viz_data).join("circle")
                .attr("class", d => `cls-${d[code]}`)
                .attr("fill", d => color(d[selectionKey]))
                .call(setFilOpc)
                .attr("cx", d => x(d.shifted.length - 1))
                .attr("cy", d => {
                    return y(d.shifted[d.shifted.length - 1]);
                }).attr("r", 3)
                .on("mouseover", onMouseOver).on("mouseout", onMouseOut);

            svg.append("g").selectAll("text").data(viz_data).join("text").text(d => {
                return (d[nameKey].includes('state') ? d[nameKey].replace('(state)', '') : d[nameKey].split(',')[0]).replace('County', '');
            })
                .attr("class", d => `cls-${d[code]} node-title`)
                .attr("font-size", '1.2em')
                .attr("dominant-baseline", 'middle')
                .attr("pointer-events", 'none')
                .attr("fill", d => color(d[selectionKey]))
                .call(setFilOpc)
                .attr("x", d => d3.min([x(d.shifted.length - 1) + 10, x(params.xmax) - 10]))
                .attr("y", d => y(d.shifted[d.shifted.length - 1]));
            // .on("mouseover", onMouseOver).on("mouseout", onMouseOut);
        }

        function draw_doubling_lines(svg) {
            guides.selectAll("path")
                .data(doubling_periods, (d) => d)
                .join("path")
                .attr("class", "guidelines")
                .attr("stroke", "orange").attr("stroke-opacity", 0.8).attr("stroke-dasharray", 2)
                .attr("d", d => d3.line()([
                    [x(0), y(params.ymin)],
                    [x(params.xmax), y(params.ymin * Math.pow(2, params.xmax / d))]
                ]));
            doubling_periodsMapper();
            guidesText.selectAll("text").data(doubling_period_labels, (d) => d.period + d.i).join("text")
                .text(d => d.period > 1 ? `Doubling every ${d.period} days` : "Doubling every day")
                .attr("font-size", '1em')
                .style("text-anchor", "end")
                .attr("fill", "orange")
                .attr("transform", d => `rotate(${get_text_rotation_angle(d.period)} ${x(d.x)} ${y(d.y)})`)
                .attr("x", d => x(d.x))
                .attr("y", d => y(d.y));
        }

        function draw_axes(svg) {
            svg.append("g").call(createXAxis);
            svg.append("g").call(createYAxis);
        }

        function onMouseOut() {
            const country_code = d3.select(this).attr("class");
            d3.selectAll(`.${country_code}`)
                .call(setFilOpc);
            d3.select("#fullname").attr("fill-opacity", 0);
            d3.select("#guides").attr("transform", `translate(0 0)`)
        }

        function onMouseOver(selected) {
            this.parentNode.appendChild(this);
            const country_code = d3.select(this).attr("class");
            d3.selectAll(`.${country_code}`).attr("fill-opacity", 1).attr("stroke-opacity", 1).attr("stroke-width", 3)
                .attr("r", 5);

            d3.select("#fullname").text(code_to_name(country_code).replace('(state)', '').split(',')[0])
                .style("text-anchor", "end")
                .attr("font-size", params.width < 500 ? '1.4em' : '2.6em')
                .attr("fill-opacity", 0.5)
                .attr("fill", "black")
                .attr("pointer-events", "none")
                .attr("font-style", "bold")
                .attr("font-family", "ProximaNova-Regular, sans-serif")
                .attr("x", x(params.xmax)).attr("y", y(params.ymax) + 20);
        }

        function isSingleStateSelected() {
            return document.getElementById('stateList2').value !== 'All' && document.getElementById('countyList2').value === 'temp' ? document.getElementById('stateList2').value : null
        }

        function init3() {
            document.getElementById('setTimespanOutput').innerText = `Show ${params.xmax} days ${y_type}`;
            document.getElementById('setOriginOutput').innerText = `Days since ${pivot} ${y_type}`;
            y_type = document.querySelector('input[name="showRadio2"]:checked').value;
            d3.select('#line-chart').select('svg').remove();
            if (document.getElementById('stateList2').value === 'All' || isSingleStateSelected()) {
                selected_regions = Object.keys(statData);
                if (!isSingleStateSelected()) {
                    document.getElementById('countyList2').disabled = true;
                    document.getElementById('countyList2').readOnly = true;
                    document.getElementById('countyList2').value = null;
                    document.getElementById('countyList2').innerText = '';
                } else {
                    document.getElementById('countyList2').disabled = false;
                    document.getElementById('countyList2').readOnly = false;
                }
                selectionKey = 'state';
                data = Object.keys(statData).map((d) => {
                    return statData[d].data;
                });
                color = d3.scaleOrdinal(data.map(d => d[selectionKey]), raw_colors).unknown("black");
            } else {
                // selected_regions = [document.getElementById('stateList2').value];
                document.getElementById('countyList2').disabled = false;
                document.getElementById('countyList2').readOnly = false;
                selectionKey = 'county';
                data = Object.keys(statData[document.getElementById('stateList2').value].county).map((obj) => {
                    return statData[document.getElementById('stateList2').value].county[obj]
                });
                selected_regions = data.map(d => d[selectionKey]);
                color = d3.scaleOrdinal(data.map(d => d[selectionKey]), raw_colors).unknown("black");
            }
            // data = new_data
            last_index = data[0].confirmed.length - 1;
            viz_data = data
                .filter(d => selected_regions.includes(d[selectionKey]))
                .filter(d => {
                    return (d[y_type][last_index][1] >= pivot)
                })
                .map(function (d) {
                    const start_idx = pivot_bisector.left(d[y_type], pivot);
                    d['shifted'] = d[y_type].slice(start_idx).map(d => d[1]);
                    return d;
                });
            min_y_values = []
            viz_data.forEach((e) => { min_y_values.push(d3.min(e.shifted.map((es) => { let es_int = parseInt(es); return !isNaN(es_int) ? es_int : null }))) });
            /* Select an absolute scale minimum of 0.9 instead of zero 
             * to avoid wrecking appearance of log scale or 
             * breaking half-assed doubling lines code by other developer
             */
            params.ymin = d3.min(min_y_values) === 0 ? 0.9 : d3.min(min_y_values);
            createYScale();
            createXScale();
            createSVG();
        }

        setSelectStateDropdown();
        init3();
    }
    
    initDashboard4 = () => {
        let d3 = window.d3;
        let new_data = window.new_data;
        var selectedTableSize = 10;
        var selectedContinentName = 'All';
        var selectedRelativeUnit = 'Count';
        var currentDate;
        var viewByField = 'state';
        var selectedRelativeFrom = '0';
        var header = [];
        var sortBy = 'confirmed';
        var stateDateList = {};
        var countyDateList = {};
        var statData = {};
        var dates = {};
        var dateOffset = (24 * 60 * 60 * 1000) * 70; //70 days
        /* var todayDate = new Date();
         var dates = d3.timeDays(todayDate.getTime() - dateOffset, todayDate);*/
        var countyData = {};
        var rawData = [];
        var rawStateData = [];

        var margin = {top: 10, right: 10, bottom: 10, left: 10};
        var height;
        var width;
        var x, y;
        var valueline2, valueline1;

        document.getElementById('radio-1c').addEventListener('change', () => {
            init();
        });
        document.getElementById('radio-2c').addEventListener('change', () => {
            init();
        });
        document.getElementById('radio-3').addEventListener('change', () => {
            init();
        });
        document.getElementById('radio-4').addEventListener('change', () => {
            init();
        });
        document.getElementById('radio-5').addEventListener('change', () => {
            init();
        });
        document.getElementById('radio-6').addEventListener('change', () => {
            init();
        });

        new_data.forEach((d) => {
            
            if ((d.county.includes('state') || !d.county.includes(',') || d.county.split(',')[0].trim().toUpperCase() === d.county.split(',')[1].trim().toUpperCase()) && !statData[d.state]) {
                statData[d.state] = d;
                const firstDate =  d.day[0];
                const date = new Date(d3.timeParse("%Y-%m-%d")("20" + firstDate[4] + firstDate[5] + '-' + firstDate[0] + firstDate[1] + '-' + (firstDate[2] + firstDate[3])));
                date.setDate(date.getDate() - 1);
                const oldDataArray = [{
                    date: date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate(),
                    type: 'state',
                    state: d.county.split(',')[0].replace('(state)', ''),
                    active:0,
                    deaths:0,
                    confirmed: 0
                }];
                let oldObj;
                d.day.filter(function (item, pos) {
                    return d.day.indexOf(item) === pos;
                }).forEach((date, i) => {
                    if(d.tstpos[i] && d.mort[i])
                    {
                        const newDate = "20" + date[4] + date[5] + '-' + date[0] + date[1] + '-' + date[2] + date[3];
                        if (!stateDateList[newDate]) {
                            stateDateList[newDate] = []
                        }
                        const active = parseInt(d.tstpos[i] ? d.tstpos[i] : 0);
                        const deaths = parseInt(d.mort[i] ? d.mort[i] : 0);
                        const newObj = {
                            date: newDate,
                            type: 'state',
                            state: d.county.split(',')[0].replace('(state)', ''),
                            active,
                            deaths,
                            confirmed: active + deaths,
                            previousDayActive: oldObj ? oldObj.active ? oldObj.active : 0 : null,
                            previousDayConfirmed: oldObj ? oldObj.confirmed ? oldObj.confirmed : 0 : null,
                            previousDayDeaths: oldObj ? oldObj.deaths ? oldObj.deaths : 0 : null,
                        };
                        oldDataArray.push(newObj);
                        newObj.oldData = [...oldDataArray];
                        stateDateList[newDate].push(newObj);
                        oldObj = newObj;
                    }
                })
            } else {
                let oldObj;
                const firstDate =  d.day[0];
                const date = new Date(d3.timeParse("%Y-%m-%d")("20" + firstDate[4] + firstDate[5] + '-' + firstDate[0] + firstDate[1] + '-' + (firstDate[2] + firstDate[3])));
                date.setDate(date.getDate() - 1);
                const oldDataArray = [{
                    date: date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate(),
                    type: 'state',
                    state: d.county.split(',')[0].replace('(state)', ''),
                    active:0,
                    deaths:0,
                    confirmed: 0
                }];
                if (!countyData[d.state]) {
                    countyData[d.state] = []
                }
                const checkCounty = d.county.split(',')[0].replace('County', '');
                if (countyData[d.state].indexOf(checkCounty)) {
                    countyData[d.state].push(checkCounty);
                }
                d.day.filter(function (item, pos) {
                    return d.day.indexOf(item) === pos;
                }).forEach((date, i) => {
                    if(d.tstpos[i] && d.mort[i])
                    {
                        const newDate = "20" + date[4] + date[5] + '-' + date[0] + date[1] + '-' + date[2] + date[3];
                        dates[newDate] = new Date("20" + date[4] + date[5], date[2] + date[3], date[0] + date[1], 0, 0, 0, 0);
                        if (!countyDateList[d.state]) {
                            countyDateList[d.state] = {}
                        }
                        if (!countyDateList[d.state][newDate]) {
                            countyDateList[d.state][newDate] = []
                        }
                        const active = parseInt(d.tstpos[i] ? d.tstpos[i] : 0);
                        const deaths = parseInt(d.mort[i] ? d.mort[i] : 0);
                        const newObj = {
                            date: newDate,
                            date: newDate,
                            type: 'county',
                            state: d.county.split(',')[0].replace('(state)', ''),
                            county: d.county.split(',')[0].replace('County', ''),
                            active,
                            deaths,
                            confirmed: active + deaths,
                            previousDayActive: oldObj ? oldObj.active ? oldObj.active : 0 : null,
                            previousDayConfirmed: oldObj ? oldObj.confirmed ? oldObj.confirmed : 0 : null,
                            previousDayDeaths: oldObj ? oldObj.deaths ? oldObj.deaths : 0 : null,
                        };
                        oldDataArray.push(newObj);
                        newObj.oldData = [...oldDataArray];
                        countyDateList[d.state][newDate].push(newObj);
                        oldObj = newObj;
                        oldDataArray.push(oldObj);
                    }
                })
            }
        });

        document.getElementById('setCurrent').max = Object.keys(dates).length - 1;
        document.getElementById('setCurrent').value = Object.keys(dates).length - 1;

        currentDate = Object.keys(dates)[Object.keys(dates).length - 1];
        document.getElementById('setCurrentOutput').innerText = `Current date: ${currentDate}`
        document.getElementById('setCurrent').addEventListener('input', (ele) => {
            selectedRelativeFrom = ele.target.value;
            currentDate = Object.keys(dates)[selectedRelativeFrom];
            document.getElementById('setCurrentOutput').innerText = `Current date: ${currentDate}`
            width = 50 - margin.left - margin.right;
            height = 50 - margin.top - margin.bottom;
            init();
        });

        setSelectStateDropdown();

        function setSelectStateDropdown() {
            document.getElementById('stateList3').innerText = '';
            Object.keys(statData).forEach((key, i) => {
                var option = document.createElement('option');
                if (i === 0) {
                    option.innerText = 'All States';
                    option.value = 'All';
                    option.selected = true;
                    document.getElementById('stateList3').appendChild(option);
                    option = document.createElement('option');
                }
                // stateText = statData[key].data.county.includes('state') ? statData[key].data.county.replace('(state)', '') : statData[key].data.county.split(',')[0]
                const stateText = statData[key].county.includes('state') ? statData[key].county.replace('(state)', '') : statData[key].county.split(',')[0]
                option.innerText = stateText;
                option.value = key;
                document.getElementById('stateList3').appendChild(option)
            });
            document.getElementById('stateList3').addEventListener('change', (selected) => {
                setCountyDropdown();
                init();
            })
        }

        function setCountyDropdown() {
            document.getElementById('countyList3').innerText = '';
            var county = countyData[document.getElementById('stateList3').value] ? countyData[document.getElementById('stateList3').value] : [];
            county.forEach((key, i) => {
                var option = document.createElement('option');
                if (i === 0) {
                    option.innerText = 'All Counties';
                    option.value = 'All';
                    option.selected = true;
                    document.getElementById('countyList3').appendChild(option);
                    option = document.createElement('option');
                }
                option.innerText = key;
                option.value = key;
                document.getElementById('countyList3').appendChild(option)
            });
            document.getElementById('countyList3').addEventListener('change', (selected) => {
                init();
            })
        }

        function createYScale() {
            y = d3.scaleLinear().range([height, 0]);
        }

        function createXScale() {
            x = d3.scaleTime().range([0, width]);
        }

        function setHeader() {
            header = [{
                title: 'Location',
                className: 'text-gray-dark text-left',
                fieldView: (td, d, headObj) => {
                    td.innerHTML = d[viewByField]
                }
            }, {
                title: '',
                className: 'text-gray-dark text-left',
                fieldView: generateProgressBar
            }, {
                title: 'Cases',
                className: 'active-text text-right',
                sortField: 'confirmed',
                onSort: sortByFilter,
                fieldView: (td, d, headObj) => {
                    getTableTdData(td, d.confirmed, d.previousDayConfirmed, 'active-text', 'recovered-text');
                }
            },
                {
                    title: 'Deaths',
                    className: 'deaths-text text-right',
                    sortField: 'deaths',
                    onSort: sortByFilter,
                    fieldView: (td, d, headObj) => {
                        getTableTdData(td, d.deaths, d.previousDayDeaths, 'deaths-text', 'recovered-text');
                    }
                }]
        }

        function sortByFilter(headObj) {
            if (sortBy.indexOf('-' + headObj.sortField) !== -1) {
                sortBy = headObj.sortField
            } else if (sortBy.indexOf(headObj.sortField) !== -1) {
                sortBy = ''
            } else {
                sortBy = '-' + headObj.sortField
            }
            init();
        }

        function getTableTdData(td, currentData, previousData, className, alertClassName) {
            let number = 0;
            if (previousData === null || previousData === 0) {

            } else if (selectedRelativeUnit === 'Percentage') {
                number = Math.floor(((currentData - previousData) * 100) / previousData) + '%'
            } else {
                number = currentData - previousData
            }
            const arrow = parseInt(number) > 0;
            if (previousData === null || previousData === 0) {
                td.innerHTML = `<span class="${className} text-bold">${currentData}</span>
            <span class="${className}">
            ${currentData !== 0 ? '<span style="font-weight: normal"></span>' : ''}</span>`;
            } else if (!arrow) {
                td.innerHTML = `<span class=" ${className} text-bold">${currentData}</span>
            <span class="${alertClassName}">
            ${arrow ? '+' : ''}${number}
            </span>`
            } else {
                td.innerHTML = `<span class="${className} text-bold">${currentData}</span>
            <span class="${className}">
            ${arrow ? '+' : ''}${number}
            </span>`;
            }
        }

        function generateProgressBar(td, data) {
            const div = document.createElement('div');
            div.style.height = '15px';
            div.width = '100%';
            td.appendChild(div);
            setTimeout(() => {
                createLineChart(div, data.oldData);
            })
        }

        function createLineChart(parent, data) {
            var margin = {top: 0, right: 0, bottom: 0, left: 0},
                width = parent.clientWidth - margin.left - margin.right,
                height = 15 - margin.top - margin.bottom;
            var parseTime = d3.timeParse("%Y-%m-%d");
            var x = d3.scaleTime().range([0, width]).domain(d3.extent(data, function (d) {
                return parseTime(d.date);
            }));
            var y = d3.scaleLinear().range([height, 0]).domain([0, d3.max(data, function (d) {
                return d.confirmed;
            })]);

            var deathline = d3.line()
                .x((d) => x(parseTime(d.date)))
                .y((d) => y(d.deaths));

            var confirmline = d3.line()
                .x((d) => x(parseTime(d.date)))
                .y((d) => y(d.confirmed));

            const svg = d3.select(parent).append('svg')
                .attr("width", width + margin.left + margin.right)
                .attr("height", height + margin.top + margin.bottom)
                .append("g")
                .attr("transform",
                    "translate(" + margin.left + "," + margin.top + ")");
            svg.append("path")
                .data([data])
                .attr("class", "death-line")
                .attr("d", deathline);
            svg.append("path")
                .data([data])
                .attr("class", "confirmed-line")
                .attr("d", confirmline);
        }

        function init() {
            selectedRelativeUnit = document.querySelector('input[name="showRadio3"]:checked').value;
            selectedTableSize = document.querySelector('input[name="tableRadio"]:checked').value;
            if (document.getElementById('stateList3').value === 'All') {
                document.getElementById('countyList3').disabled = true;
                document.getElementById('countyList3').readOnly = true;
                document.getElementById('countyList3').value = null;
                document.getElementById('countyList3').innerText = '';
                viewByField = 'state'
            } else {
                document.getElementById('countyList3').disabled = false;
                document.getElementById('countyList3').readOnly = false;
                viewByField = 'county'
            }
            createYScale();
            createXScale();
            setHeader();
            drawTable();
        }

        function drawTable(data) {
            document.getElementById('tableBody').innerHTML = '';
            drawHeader();
            drawData();
        }

        function drawHeader() {
            const head = document.getElementById('tableHeader');
            head.innerHTML = '';
            header.forEach((headObj) => {
                const th = document.createElement('th');
                th.className = headObj.className;
                if (headObj.sortField) {
                    const sortByActive = sortBy.indexOf(headObj.sortField) !== -1
                    const btn = document.createElement('button');
                    btn.className = "btn btn-invisible order-column px-1";
                    btn.innerHTML = `<span class="text-gray-dark">${sortByActive ? sortBy.includes('-') ? '&#8593;' : '&#8595;' : ''}</span>
                                <span class="${headObj.className}">${headObj.title}</span>`
                    btn.onclick = () => headObj.onSort(headObj)
                    th.appendChild(btn);
                } else {
                    const btn = document.createElement('button');
                    btn.className = "btn btn-invisible order-column cursor-default";
                    btn.innerHTML = `<span class="text-gray-dark"></span>
                                <span class="${headObj.className}">${headObj.title}</span>`
                    th.appendChild(btn);
                }
                head.appendChild(th);
            });
        }

        function drawData() {
            const tbody = document.getElementById('tableBody');
            tbody.innerHTML = '';
            let filterData = document.getElementById('stateList3').value === 'All' ? stateDateList[currentDate] :
                countyDateList[document.getElementById('stateList3').value][currentDate]
                    .filter((d) => d.type === 'county' && document.getElementById('countyList3').value !== 'All' ? d.county === document.getElementById('countyList3').value : true)
            if (sortBy !== '') {
                filterData = filterData.sort((b, a) => {
                    if (sortBy.indexOf('-') !== -1) {
                        return parseInt(b[sortBy.replace('-', '')]) - parseInt(a[sortBy.replace('-', '')])
                    }
                    return parseInt(a[sortBy]) - parseInt(b[sortBy])
                });
            }

            if (selectedTableSize !== 'All') {
                filterData = filterData.slice(0, selectedTableSize)
            }
            filterData.forEach((obj, i) => {
                const tr = document.createElement('tr');
                tbody.appendChild(tr);
                header.forEach((headObj) => {
                    const td = document.createElement('td');
                    td.id = obj.type === "state" ? `${i}${obj.state.trim()}` : `${i}${obj.county.trim()}`;
                    td.className = 'text-gray' + (headObj.sortField ? ' text-number' : '');
                    td.style.width = 100/ header.length + '%';
                    headObj.fieldView(td, obj, headObj);
                    tr.appendChild(td)
                })
            })
        }

        init();
    }
}

export default MapRoomCovidRoot;


// WEBPACK FOOTER //
// ./src/components/Root/MapRoomCovidRoot.js